const Howl = require("howler").Howl;
const Howler = require("howler").Howler;
let channelMusic;
let channelVoice;

module.exports = {
	initialize(soundsData) {
		let soundOptions;
		const soundNames = Object.getOwnPropertyNames(soundsData);
		this.sounds = soundNames.reduce((memo, name) => {
			soundOptions = soundsData[name];
			// Allow strings instead of objects, for when all that is needed is a URL
			if (typeof soundOptions === "string") {
				soundOptions = { src: [soundOptions], autoPlay: false };
			}
			return { ...memo, [name]: new Howl(soundOptions) };
		}, {});
			Howler.volume(0) // audio mute to start
		return this.sounds;
	},

	muteAudio(yayNay) {
		if (yayNay) Howler.volume(0);
		else Howler.volume(1);
	},

	playfx(soundName, channel) {
		const sound = this.sounds[soundName];
		sound.play();
	},

	play(soundName, channel, duration = 1000) {
		if (soundName === undefined) return; // no audio to handle, so cancelling
		// console.log(soundName);
		const sound = this.sounds[soundName];
		// MUSIC AND DIALOG
		if (channel === "music") {
			// console.log("playing music/dialog channels");
			
			if (channelMusic !== undefined) { // fade out music,  if already playing, then play new jam
				channelMusic.fade(1, 0, duration);
				channelMusic.once('fade', (ref) => {
					channelMusic.stop();
					channelMusic = sound;
					channelMusic.play();
					channelMusic.fade(0, 1, duration);
					return;
				})
				return;
			} else { // just play new jam
				channelMusic = sound;
				channelMusic.play();
				return;
			}
		}
		if (channel === "voice" || "dialog") {
			if (channelVoice !== undefined) channelVoice.stop();
			channelVoice = sound.play();
			channelVoice = sound; // save for later
			return;
		}
	},

	fade (soundName, channel) {
		// console.log("fade function yo");
		// if (channel === "music") {
		// 	if (channelMusic !== undefined) channelMusic.fade(1, 0, 1000);
		// }
		// if (channel === "voice") {
		// 	if (channelVoice !== undefined) channelVoice.fade(1, 0, 1000);
		// }
	},

	stopVoice () {
		if (channelVoice !== undefined) channelVoice.stop();
	},

	stop(soundName, spriteName) {
		const sound = this.sounds[soundName];
		if (typeof sound !== "undefined") sound.stop(spriteName);
	},

	channelStop(soundName, spriteName) {
		const sound = this.sounds[soundName];
		sound.stop();
	}
};



// WEBPACK FOOTER //
// ./src/middleware/howler_integration.js